
export const getAccountTypeListApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `/rate_account_types${queryString ? `?${queryString}` : ''}`;
};


export const addAccountTypeApi = (params) => {
    return `/rate_account_types`;
};
export const restoreAccountTypeApi = (params) => {
    return `/rate_account_types/restore`;
};

export const updateAccountTypeApi = (params) => {
    return `/rate_account_types/${params?.asset_slug}`;
};

export const deleteAccountTypeApi = (params) => {
    return `rate_account_types`;
};

export const exportAccountTypeApi = (leaseId) => {
    return `lease/${leaseId}/rate_account_types`;
};
